(function () {
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function threshold() {
    var e = document.querySelector('[data-ws-threshold]');
    if (!e) return 0;
    var n = parseFloat(String(e.getAttribute('data-ws-threshold')).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  var truck = '<svg width="15" height="15" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h16v13H3z"/><path d="M19 13h5.5l4.5 4.5V22h-10"/><circle cx="8.5" cy="23.5" r="2.5"/><circle cx="23.5" cy="23.5" r="2.5"/></svg>';

  document.querySelectorAll('[data-ws-arrive]').forEach(function (el) {
    var dd = parseInt(el.getAttribute('data-ws-arrive'), 10) || 3;
    var d = new Date(), n = 0;
    while (n < dd) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; }
    el.textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  });

  /* ---------- Basket drawer ---------- */
  var drawer = document.querySelector('[data-ws-drawer]');
  var lastFocus = null;
  function renderCart(cart) {
    document.querySelectorAll('[data-ws-count]').forEach(function (e) { e.textContent = cart.item_count; });
    if (!drawer) return;
    var lines = drawer.querySelector('[data-ws-lines]');
    if (!cart.items.length) {
      lines.innerHTML = '<p class="ws-empty">Your basket is empty.</p>';
    } else {
      lines.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : '';
        var meta = [it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '', plan].filter(Boolean).join('. ');
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="ws-line">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '<span></span>') +
          '<div><div class="ws-line__t">' + esc(it.product_title) + '</div>' + (meta ? '<div class="ws-line__m">' + esc(meta) + '</div>' : '') +
          '<div style="display:flex;align-items:center"><span class="ws-qty"><button type="button" data-ws-line="' + (i + 1) + '" data-ws-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-ws-line="' + (i + 1) + '" data-ws-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="ws-rm" data-ws-line="' + (i + 1) + '" data-ws-q="0">Remove</button></div></div>' +
          '<div class="ws-line__p">' + was + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    var sub = drawer.querySelector('[data-ws-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var co = drawer.querySelector('[data-ws-checkout]');
    if (co) co.classList.toggle('is-disabled', !cart.items.length);
    var t = threshold();
    var ship = drawer.querySelector('[data-ws-ship]');
    if (ship) {
      if (t > 0 && cart.items.length) {
        ship.hidden = false;
        var left = t - cart.total_price;
        drawer.querySelector('[data-ws-ship-text]').innerHTML = left > 0 ? 'You’re <strong>' + money(left) + '</strong> away from free UK delivery' : '<strong>You’ve got free UK delivery</strong>';
        drawer.querySelector('[data-ws-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price / t * 100)) + '%';
      } else { ship.hidden = true; }
    }
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    document.body.style.overflow = 'hidden';
    var x = drawer.querySelector('.ws-drawer__x'); if (x) setTimeout(function () { x.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ws-cart-close]')) { closeDrawer(); return; }
      var b = e.target.closest('[data-ws-line]');
      if (b) {
        b.disabled = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(b.getAttribute('data-ws-line'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-ws-q'), 10)) }) })
          .then(function (r) { return r.json(); }).then(renderCart).catch(function () { window.location.href = '/cart'; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  document.querySelectorAll('[data-ws-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      getCart().then(function (c) { renderCart(c); openDrawer(); }).catch(function () { window.location.href = '/cart'; });
    });
  });

  /* ---------- Product page ---------- */
  var root = document.querySelector('[data-ws-product]');
  if (!root) return;
  var json = root.querySelector('[data-ws-json]');
  if (!json) return;
  var data = JSON.parse(json.textContent);
  var state = { v: data.defaultIndex || 0, sub: !!data.hasPlan };
  var idInput = document.querySelector('[data-ws-id]');
  var planInput = document.querySelector('[data-ws-plan]');
  var form = document.getElementById('ws-form');
  function priceFor(i, sub) { var v = data.variants[i]; return (sub && v.planPrice) ? v.planPrice : v.price; }

  var t = threshold();
  if (t > 0) {
    root.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) {
      var v = data.variants[i];
      if (v && v.price >= t) { var s = document.createElement('span'); s.className = 'ws-freeship'; s.innerHTML = truck + 'Free delivery'; b.appendChild(s); }
    });
  }
  var arrive = root.querySelector('[data-ws-arrive]');
  var submitBtn = form ? form.querySelector('[type="submit"]') : null;
  if (arrive && submitBtn && !submitBtn.disabled) {
    var p = arrive.closest('p');
    if (p) { var st = document.createElement('p'); st.className = 'ws-stock'; st.innerHTML = '<i aria-hidden="true"></i>In stock and ready to send'; p.parentNode.insertBefore(st, p); }
  }

  function render() {
    var v = data.variants[state.v];
    var cur = priceFor(state.v, state.sub);
    var full = data.variants[0].price * v.qty;
    document.querySelectorAll('[data-ws-total]').forEach(function (e) { e.textContent = money(cur); });
    var save = full > cur ? Math.round((1 - cur / full) * 100) : 0;
    var cmp = root.querySelector('[data-ws-compare]');
    if (cmp) {
      if (save > 0) { cmp.hidden = false; cmp.querySelector('[data-ws-full]').textContent = money(full); cmp.querySelector('[data-ws-save]').textContent = 'Save ' + save + '%'; }
      else { cmp.hidden = true; }
    }
    root.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) {
      var on = i === state.v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var e = b.querySelector('[data-ws-each]');
      if (e) e.textContent = money(Math.round(priceFor(i, state.sub) / data.variants[i].qty)) + ' each';
    });
    root.querySelectorAll('[data-ws-mode]').forEach(function (b) {
      var on = (b.getAttribute('data-ws-mode') === 'sub') === state.sub;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (idInput) idInput.value = v.id;
    if (planInput) { planInput.value = state.sub && v.planId ? v.planId : ''; planInput.disabled = !(state.sub && v.planId); }
    document.querySelectorAll('[data-ws-addlabel]').forEach(function (e) { e.textContent = state.sub ? 'Subscribe now' : 'Add to basket'; });
  }
  root.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) { b.addEventListener('click', function () { state.v = i; render(); }); });
  root.querySelectorAll('[data-ws-mode]').forEach(function (b) { b.addEventListener('click', function () { state.sub = b.getAttribute('data-ws-mode') === 'sub'; render(); }); });
  var main = root.querySelector('[data-ws-main]');
  root.querySelectorAll('[data-ws-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      if (main) { main.src = th.getAttribute('data-src'); main.srcset = ''; main.alt = th.getAttribute('data-alt') || ''; }
      root.querySelectorAll('[data-ws-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === th); x.setAttribute('aria-pressed', x === th ? 'true' : 'false'); });
    });
  });

  if (form && drawer && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = document.querySelectorAll('[form="ws-form"], #ws-form [type="submit"]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var old = form.parentNode.querySelector('.ws-err'); if (old) old.remove();
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.j && (res.j.description || res.j.message) || 'Something went wrong. Please try again.'); }
          return getCart();
        })
        .then(function (c) { renderCart(c); openDrawer(); })
        .catch(function (err) {
          var m = document.createElement('p'); m.className = 'ws-err'; m.setAttribute('role', 'alert'); m.textContent = err.message || 'Something went wrong. Please try again.';
          form.insertAdjacentElement('afterend', m);
        })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    });
  }
  render();
})();
